module.exports = __webpack_public_path__ + "img/wallet1.b88e0986.png";